'use client'

import React from 'react'
import { CartCheck, Diskette } from 'solar-icons'
import { useCheckout } from '@/lib/hooks'
import { cn } from '@/lib/utils'

import { Button, CmdChip, LoadingDots } from '@/components/ui'
import { SaveOrder } from '@/components/molecules'

interface CartFooterProps extends React.ComponentPropsWithoutRef<'div'> {}

export const CartFooter = ({ className, ...restProps }: CartFooterProps) => {
  const { setIsCheckout, getPayments, queryParams } = useCheckout()
  const [isStartingCheckout, setIsStartingCheckout] = React.useState(false)

  const handleStartCheckout = async () => {
    setIsStartingCheckout(true)
    getPayments({
      cartId: queryParams.cartId,
      callbackFn: (data: any) => {
        if (!data) {
          setIsStartingCheckout(false)
          return
        }
        setIsCheckout(true)
      },
    })
  }

  return (
    <div
      className={cn('flex flex-col items-center gap-2 lg:flex-row', className)}
      {...restProps}
    >
      <SaveOrder />

      <Button
        variant="brand"
        className="w-full justify-start gap-2"
        size="lg"
        onClick={handleStartCheckout}
      >
        {isStartingCheckout && <LoadingDots dotClassName="bg-white" />}
        {!isStartingCheckout && (
          <>
            <CartCheck strokeWidth={1.2} />
            <span className="flex-grow text-left">Checkout</span>
            <CmdChip variant="dark" className="py-1 text-xs">
              12
            </CmdChip>
          </>
        )}
      </Button>
    </div>
  )
}
